const BizServePortalIntro = () => {
  return (
    <section className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Everything Your Business Needs, All in One Place
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Whether you're a freelancer just starting out, a growing startup, or
            a government contractor, BizServe provides the tools, guidance, and
            expert support you need to succeed.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">🚀</span>
            </div>
            <h3 className="text-xl font-semibold mb-2">
              For Startups & Freelancers
            </h3>
            <p className="text-muted-foreground">
              Get your business off the ground with step-by-step guidance, from
              formation to first customers.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">🏢</span>
            </div>
            <h3 className="text-xl font-semibold mb-2">
              For Growing Businesses
            </h3>
            <p className="text-muted-foreground">
              Scale efficiently with integrated tools for HR, accounting,
              compliance, and growth.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">🏛️</span>
            </div>
            <h3 className="text-xl font-semibold mb-2">
              For Government Contractors
            </h3>
            <p className="text-muted-foreground">
              Navigate complex requirements with SAM registration, DCAA
              compliance, and proposal support.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BizServePortalIntro;
